import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * Exige usuário logado com 1º pagamento (ou admin).
 * Sem pagar → landing /.
 */
const PaidRoute = ({ children }) => {
  const { user, loading, hasPaidAccess } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user || !hasPaidAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PaidRoute;
